import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogModule,
	MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Collector } from '@lmc-app/shared/interface/collector.interface';
import { Agency } from '@lmc-app/shared/interface/agency.interface';

export interface CollectorSelectorModalData {
	agency: Agency;
	selectedCollector?: Collector;
}

@Component({
	standalone: true,
	selector: 'app-collector-selector-modal',
	templateUrl: 'collector-selector-modal.component.html',
	styleUrls: ['collector-selector-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatTableModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
	],
})
export class CollectorSelectorModalComponent implements OnInit {
	readonly dialogRef = inject(MatDialogRef<CollectorSelectorModalComponent>);
	readonly data = inject<CollectorSelectorModalData>(MAT_DIALOG_DATA);
	dataSource = new MatTableDataSource<Collector>([]);
	selectedCollector: Collector | null = null;
	loading = false;
	displayedColumns: string[] = [
		'select',
		'name',
		'phone',
		'extension',
		'email',
		'agent',
		'owner',
	];
	private readonly apiService = inject(LegacyApiService);

	ngOnInit() {
		this.loadCollectors();
	}

	loadCollectors() {
		this.loading = true;
		this.apiService.getCollectorsByAgencyId(this.data.agency.id).subscribe({
			next: (res) => {
				if (res.message.statusCode === 200) {
					const unknownCollector = {
						id: '2390707000656186689',
						name: 'Unknown',
					};
					const apiCollectors = JSON.parse(res.message.body).data.map(
						(collector: any) => ({
							...collector,
							name: `${collector.First_Name || ''} ${
								collector.Last_Name || ''
							}`.trim(),
						})
					);
					this.dataSource.data = [unknownCollector, ...apiCollectors];

					// Set initial selected collector if provided
					if (this.data.selectedCollector) {
						this.selectedCollector =
							this.dataSource.data.find(
								(c) => c.id === this.data.selectedCollector?.id
							) || null;
					}
				} else {
					this.dataSource.data = [];
				}
				this.loading = false;
			},
			error: (error) => {
				console.error(error);
				this.dataSource.data = [];
				this.loading = false;
			},
		});
	}

	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	selectCollector(collector: Collector) {
		this.dialogRef.close(collector);
	}

	onCancel() {
		this.dialogRef.close(null);
	}

	createNewCollector() {
		// Disabled for now
		// Will be implemented in the future
	}
}